import { render, staticRenderFns } from "./ClosingDateComponent.vue?vue&type=template&id=35168a12&"
import script from "./ClosingDateComponent.vue?vue&type=script&lang=js&"
export * from "./ClosingDateComponent.vue?vue&type=script&lang=js&"
import style0 from "./ClosingDateComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports